import { UpiPaymentDetails } from "./upi-payment-details";

export class UpiPayment{
    merchantTranId:string;
    locId:number;

    amount: number;
    fromLocationCode: number;
    upiPaymentDetails: UpiPaymentDetails[]=[];
}